import { FC, useEffect } from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet, useLocation } from "react-router-dom";

import { Paths } from "router/routes/paths";
import VerifySessionRoute from "router/VerifySessionRoute/VerifySessionRoute";
import { RootState, useAppDispatch } from "store";
import { setRedirectPath } from "store/actions/authentication";
import { getIsIdentified } from "store/selectors";

const VerifiedAuthLayout: FC = () => {
  const dispatch = useAppDispatch();
  const location = useLocation();

  const isAuthenticated = useSelector((state: RootState) => state.authentication.authenticated);
  const isSessionVerified = useSelector((state: RootState) => state.authentication.sessionVerified);
  const isUserIdentified = useSelector(getIsIdentified);

  const needsAuthentication = !isAuthenticated;
  const needsSessionVerification = !isSessionVerified && !isUserIdentified;

  useEffect(() => {
    if (needsAuthentication) {
      dispatch(setRedirectPath(`${location.pathname}${location.search}`));
    }
  }, [needsAuthentication, dispatch, location.pathname, location.search]);

  if (needsAuthentication) {
    return <Navigate to={Paths.login} replace />;
  }

  if (needsSessionVerification) {
    return <VerifySessionRoute />;
  }

  return <Outlet />;
};

export default VerifiedAuthLayout;
